export default "__VITE_ASSET__DyJ9gfdm__"